/* cc-related-more — grows "You may also like" to up to 20 items
   (Tony 2026-07-11: the dropped FBT app showed up to 20; Shopify's
   recommendations API caps a single intent at 10).
   Custom element inside the related-products section markup —
   connectedCallback fires after ProductRecommendations' innerHTML swap
   (sanctioned re-render hook, NO MutationObserver). Fill order:
   1. intent=complementary section render (server-rendered THE cards,
      stars intact; empty unless configured in Search & Discovery);
   2. top-up from the product's primary collection via products.json,
      rendered with ccRenderProductCard (client cards — star-less tail,
      sold-out products skipped).
   Dawn's SliderComponent re-runs initPages via its ResizeObserver when
   items append; cc-carousel-bar re-syncs the same way. */

(() => {
  if (customElements.get('cc-related-more')) return;

  const TARGET = 20;

  class CCRelatedMore extends HTMLElement {
    connectedCallback() {
      if (this.dataset.done === '1') return;
      this.dataset.done = '1';
      this.extend();
    }

    async extend() {
      const host = this.closest('product-recommendations');
      const ul = host ? host.querySelector('ul.slider') : null;
      if (!host || !ul) return;

      const have = new Set(
        [...ul.querySelectorAll('.cc-cprod')].map((c) => c.dataset.handle)
      );
      if (this.dataset.productHandle) have.add(this.dataset.productHandle);
      let count = ul.children.length;
      ul.dataset.ccInitialCount = count;
      if (count >= TARGET) return;

      /* 1 — complementary intent, server-rendered (stars intact) */
      try {
        const url = new URL(host.dataset.url, location.origin);
        url.searchParams.set('limit', '10');
        url.searchParams.set('intent', 'complementary');
        url.searchParams.set('product_id', host.dataset.productId);
        url.searchParams.set('section_id', host.dataset.sectionId);
        const text = await fetch(url).then((r) => (r.ok ? r.text() : ''));
        if (text) {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          for (const li of doc.querySelectorAll('ul.slider > li')) {
            if (count >= TARGET) break;
            const card = li.querySelector('.cc-cprod');
            const h = card && card.dataset.handle;
            if (!h || have.has(h)) continue;
            have.add(h);
            count++;
            li.id = 'Slide-related-more-' + count;
            ul.appendChild(document.importNode(li, true));
          }
        }
      } catch (e) {
        /* noop — top-up still runs */
      }

      /* 2 — primary-collection top-up (client THE cards) */
      if (count < TARGET && this.dataset.collection && window.ccRenderProductCard) {
        try {
          const data = await fetch(
            '/collections/' + this.dataset.collection + '/products.json?limit=30'
          ).then((r) => (r.ok ? r.json() : null));
          for (const p of (data && data.products) || []) {
            if (count >= TARGET) break;
            if (have.has(p.handle)) continue;
            if (!(p.variants || []).some((v) => v.available)) continue;
            have.add(p.handle);
            count++;
            const li = document.createElement('li');
            li.id = 'Slide-related-more-' + count;
            li.className = 'grid__item slider__slide';
            li.innerHTML = window.ccRenderProductCard(p);
            ul.appendChild(li);
          }
        } catch (e) {
          /* noop */
        }
      }

      if (count > ul.dataset.ccInitialCount) {
        /* Dawn's SliderComponent RO watches the ul BOX (unchanged by
           appends) — refresh its paging + tell cc-carousel-bar directly */
        const sc = ul.closest('slider-component');
        /* resetPages re-queries [id^="Slide-"]; initPages alone filters the
           STALE list Dawn cached in the constructor — appended cards never
           counted and the next-arrow grayed out at the old end */
        if (sc && typeof sc.resetPages === 'function') sc.resetPages();
        else if (sc && typeof sc.initPages === 'function') sc.initPages();
        sc && sc.dispatchEvent(new CustomEvent('cc:items-changed'));
      }
    }
  }

  customElements.define('cc-related-more', CCRelatedMore);
})();
